export const initialLayout: any = [
  {
    w: 6,
    h: 2,
    x: 0,
    y: 0,
    i: '0',
    aspectRatio: '2:1',
  },
  {
    w: 3,
    h: 2,
    x: 9,
    y: 0,
    i: '1',
    aspectRatio: '3:2',
  },
  {
    w: 3,
    h: 2,
    x: 6,
    y: 0,
    i: '2',
    aspectRatio: '3:2',
  },
  {
    w: 5,
    h: 2,
    x: 0,
    y: 2,
    i: '3',
    aspectRatio: '2:1',
  },
  {
    w: 7,
    h: 2,
    x: 5,
    y: 2,
    i: '4',
    aspectRatio: '3:2',
  },
];
